import alt from 'components/Dispatcher';

class CallHistoryActions {
  constructor() {
    this.generateActions('hoverComment', 'unhoverComment', 'hoverHighlight', 'unhoverHighlight');
  }
}

export default alt.createActions(CallHistoryActions);
